var render, staticRenderFns
import script from "./Bar.vue?vue&type=script&lang=js&"
export * from "./Bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('529669b2')) {
      api.createRecord('529669b2', component.options)
    } else {
      api.reload('529669b2', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/Charts/Bar.vue"
export default component.exports